var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoMutedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1D2939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1675_650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29982 20.5802L19.1598 10.7202C19.0498 10.6902 18.9398 10.6802 18.8198 10.6802H9.81982C8.98982 10.6802 8.31982 11.3502 8.31982 12.1802V19.1802C8.31982 19.8302 8.72982 20.3802 9.29982 20.5802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6001 11.7299L20.3201 13.3699V12.3869L24.1741 8.53294C24.3691 8.33794 24.3691 8.02094 24.1741 7.82594C23.9791 7.63094 23.6621 7.63094 23.4671 7.82594L8.46705 22.8259C8.27205 23.0209 8.27205 23.3379 8.46705 23.5329C8.66205 23.7279 8.97905 23.7279 9.17405 23.5329L12.0271 20.6799H18.8201C19.6501 20.6799 20.3201 20.0099 20.3201 19.1799V17.9899L23.6001 19.6299C23.7851 19.7089 23.9561 19.6879 24.0801 19.6099C24.2301 19.5099 24.3201 19.3499 24.3201 19.1799V12.1799C24.3201 12.0099 24.2301 11.8499 24.0801 11.7499C23.9401 11.6599 23.7501 11.6499 23.6001 11.7299Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1675_650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8.31982 7.68018)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMutedIcon);
export default __webpack_public_path__ + "static/media/video-muted-icon.a4993b64.svg";
export { ForwardRef as ReactComponent };